import React, { useState, useRef } from "react";
import { extractFileExtensions } from "../../services/utils";
import { useNotValidFilesState } from "../../states/useStates";
import { fileValidation } from "../../services/utils";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

function UploadZone({
  handleFileChange,
  formatExplanation,
  validFormat,
  connectorType,
}) {
  const [dragActive, setDragActive] = useState(false);
  const [notValidFiles, setNotValidFiles] = useNotValidFilesState();
  // const [validFiles, setValidFiles] = useState();
  const inputRef = useRef(null);

  // handle drag events
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      // at least one file has been dropped so do something
      const validFiles = fileValidation(validFormat, e.dataTransfer.files);
      // console.log("dropped files: ", validFiles);
      handleFileChange(validFiles);
    }
  };

  const handleBrowseFile = (e) => {
    const validFiles = fileValidation(
      validFormat,
      e.target.files,
      connectorType
    );
    handleFileChange(validFiles);
  };

  // triggers the input when the button is clicked
  const onButtonClick = () => {
    inputRef.current.click();
  };

  return (
    <div className="p-5 bg-white rounded shadow h-60 w-full lg:h-96">
      <div
        className={cn(
          "flex items-center justify-center w-full p-5 border border-dotted border-gray-600/90 rounded h-full ",
          dragActive && "bg-primary/30"
        )}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
        <div className="flex flex-col items-center justify-center pt-5 pb-6">
          <img
            src="/images/documents.png"
            alt="upload"
            className="w-20 h-20 mb-3 opacity-50"
          />
          {/* <p className="text-sm text-gray-800 text-opacity-50">
            <span className="font-semibold">Drag & Drop</span>
          </p>
          <p className="text-sm text-gray-800 text-opacity-50 mb-5">
            Your files, or
            <span
              className="underline cursor-pointer ml-1"
              onClick={onButtonClick}
            >
              browse
            </span>
          </p> */}
          <Button onClick={onButtonClick} className="w-24 mb-2">
            Browse
          </Button>
          <p className="text-xs text-gray-800 text-opacity-50">
            Accepted Format:
          </p>
          <ul className="flex items-center gap-1 text-xs text-gray-800 text-opacity-50">
            {validFormat.map((item, index) => {
              return <li key={index}>{item}</li>;
            })}
          </ul>
        </div>
        <input
          ref={inputRef}
          id="dropzone-file"
          type="file"
          className="hidden"
          onChange={(e) => handleBrowseFile(e)}
          multiple
        />
      </div>
    </div>
  );
}

export default UploadZone;
